import { buildAppUrl } from './appOrigin'

export const makeProjectLink = (projectId: string | number) => (
    buildAppUrl(`/projects/${projectId}`).toString()
)

export const makeProjectTaskLink = (
    projectId: string | number,
    taskId: string | number,
    view: 'board' | 'list' = 'board',
) => {
    const url = buildAppUrl(`/projects/${projectId}`)

    url.searchParams.set('view', view)
    url.searchParams.set('task', String(taskId))

    return url.toString()
}

const fallbackCopyText = (text: string) => {
    const textarea = document.createElement('textarea')
    textarea.value = text
    textarea.setAttribute('readonly', '')
    textarea.style.position = 'fixed'
    textarea.style.opacity = '0'
    document.body.appendChild(textarea)
    textarea.select()
    document.execCommand('copy')
    document.body.removeChild(textarea)
}

export const copyProjectLink = async (projectId: string | number) => {
    const link = makeProjectLink(projectId)

    if (navigator.clipboard?.writeText && window.isSecureContext) {
        await navigator.clipboard.writeText(link)
        return link
    }

    fallbackCopyText(link)
    return link
}

export const copyProjectTaskLink = async (
    projectId: string | number,
    taskId: string | number,
    view: 'board' | 'list' = 'board',
) => {
    const link = makeProjectTaskLink(projectId, taskId, view)

    if (navigator.clipboard?.writeText && window.isSecureContext) {
        await navigator.clipboard.writeText(link)
        return link
    }

    fallbackCopyText(link)
    return link
}
